import { NoticeExtractorDocumentDetailsResponseDto } from 'app/API';
import { DataRows } from '../DataRows';

type TProps = {
  data?: NoticeExtractorDocumentDetailsResponseDto;
};

export function DocumentDetailsCard({ data }: TProps) {
  return (
    <section className="min-w-0 rounded-[10px] border border-border bg-surface p-3.5">
      <h3 className="mb-2.5 text-sm font-bold leading-5 text-foreground">Document details</h3>
      <DataRows
        rows={[
          { label: 'Title', value: data?.title },
          { label: 'Filing date', value: data?.filing_date },
          { label: 'Service date', value: data?.service_date },
        ]}
      />
    </section>
  );
}
